import React from "react";
import {
  Hero,
  Benefits,
  BenefitsTable,
  DownloadDocuments,
  Disclaimer,
  ContactForm,
  InvestmentCalculatorPlaceholder,
} from "agronomist-ui-components";

import PageTemplate from "../helpers/PageTemplate";
import { getBreadcrumbs } from "../helpers/fakeBreadcrumbs";
import TempShareButtonsComponent from "../helpers/TempShareButtonsComponent";
import { scrollToElement, onContactSubmit } from "../helpers/utils";
import CalculatorPage from "../../components/views/CalculatorPage/CalculatorPage";

import imageUrl from "../assets/images/kredyt_18.png";
import fileA from "../../assets/prf/pdf/INFORMACJA O AGENCIE - fuzja Generali-Concordia.pdf";
import fileB from "../../assets/prf/pdf/OWU BNPP_CASHCPI_3_3.3.2020 _Cardif_Rzeczówka Light.pdf";
import fileC from "../../assets/prf/pdf/Karta Produktu_BNPP_CASHCPI_3_3. 3.2020_Cardif_Rzeczówka Light.pdf";

const COPY = {
  HERO: {
    breadcrumbs: getBreadcrumbs("Kredyt na mniejsze instalacje fotowoltaiczne"),
    title: "Kredyt na mniejsze instalacje fotowoltaiczne",
    description:
      "Chciałbyś zamontować  instalację fotowoltaiczną i wykorzystywać wyprodukowaną energię w Twoim gospodarstwie rolnym? Szukasz szybkiego finansowania?",
    imageUrl,
    button: {
      title: "Sprawdź ofertę",
      onClick: () => scrollToElement("#ofert"),
    },
  },
  BENEFITS: {
    title: "Jakie są korzyści z finansowania?",
    subtitle: "Szybkie finansowanie inwestycji w instalację fotowoltaiczną.",
    benefits: [
      {
        title: "Proste procedury i minimum formalności",
        description:
          "Szybka decyzja i brak konieczności ustanawiania zabezpieczeń",
        icon: "TickRounded",
      },
      {
        title: "Możliwość ubezpieczenia spłaty kredytu",
        description:
          "Dzięki ubezpieczeniu spłacana jest rata kredytu bądź całe saldo zadłużenia",
        icon: "PaperShield",
      },
      {
        title: "Elastyczny okres kredytowania",
        description: "Maksymalnie do 84 miesięcy",
        icon: "Calendar",
      },
    ],
  },
  BENEFITS2: {
    title: "Jak to działa?",
    subtitle:
      "Kredytomat to prosta i przyjazna wyszukiwarka oferty bankowej ułatwiająca dobór produktów najbardziej dopasowanych do Twoich potrzeb związanych z prowadzeniem gospodarstwa rolnego.",
    benefits: [
      {
        title: "Znajdź produkt spełniający Twoje oczekiwania",
        description:
          "Ustaw interesujące Cię kryteria wyszukiwania, aby otrzymać ofertę jak najbardziej dopasowaną do Twoich potrzeb.",
        icon: "SearchBulb",
      },
      {
        title: "Skontaktuj się z nami",
        description:
          "Zapisz propozycję oferty i pozostaw swoje dane kontaktowe lub odwiedź nas w Oddziale.",
        icon: "MessagesBulb",
      },
      {
        title: "Gotowe! Możesz realizować swoje potrzeby",
        description:
          "Ciesz się ze zrealizowanej inwestycji w Twoim gospodarstwie!",
        icon: "HandBulb",
      },
    ],
    withArrow: true,
  },
  DOWNLOAD_DOCUMENTS: {
    title: "Dokumenty do pobrania",
    files: [
      {
        name: "Informacja o Agencie",
        details: "Produkt 2021, Plik .pdf 0.3mb",
        url: fileA,
      },
      {
        name: "OWU Cardif Rzeczówka Light",
        details: "Produkt 2021, Plik .pdf 0.2mb",
        url: fileB,
      },
      {
        name: "Karta Produktu",
        details: "Produkt 2021, Plik .pdf 0.1mb",
        url: fileC,
      },
    ],
  },
  DISCLAIMER: {
    notes: [
      "Niniejszy materiał ma charakter wyłącznie reklamowy i informacyjny oraz nie stanowi oferty w rozumieniu Kodeksu Cywilnego. Ostateczna decyzja o udzieleniu kredytu i warunkach kredytowania uzależniona jest od wewnętrznych przepisów Banku oraz wyniku przeprowadzonej przez Bank analizy zdolności kredytowej Klienta. Świadczenie usług i produktów bankowych oraz ochrony ubezpieczeniowej następuje na warunkach szczegółowo określonych w umowie zawartej z Klientem oraz w Ogólnych Warunkach Ubezpieczenia. Bank BNP Paribas działa jako agent ubezpieczeniowy Towarzystwa Ubezpieczeń na Życie Cardif Polska S.A. z siedzibą w Warszawie przy Pl. Piłsudskiego 2. Informacja o produktach i usługach bankowych dostępna jest w regulaminach, taryfie prowizji i opłat, dostępnych w oddziałach Banku oraz na stronie <a href='https://www.bnpparibas.pl'>www.bnpparibas.pl</a>.",
    ],
  },
  BENEFITS_TABLE: {
    footer: {
      text: "Możliwość ubezpieczenia spłaty CARDIF",
    },
    packages: [
      "Przewagi produktu",
      "Maksymalny okres finansowania",
      "Maksymalna kwota kredytu",
      "Zabezpieczenie",
      "Częstotliwość spłaty kapitału",
    ],
    features: [
      {
        title: "Rzeczówka Light",
        subtitle: "dla mniejszych gospodarstw rolnych",
        list: [
          "Bez zabezpieczeń rzeczowych, finansowanie kwoty brutto",
          "7 lat",
          "60 000 PLN",
          "Nie\nMożliwość ubezpieczenia spłaty kredytu",
          "Raty miesięczne lub kwartalne",
        ],
        footer: {
          text: "ZAPYTAJ O OFERTĘ",
          onClick: () => {
            window.location.href = `/kredytomat/kontakt?product_url=${
              window.location.pathname
            }&product_name=Rzeczówka Light`;
          },
        },
      },
    ],
  },
};

const KredytyNaInstalacjePVRzeczowka = () => (
  <PageTemplate
    meta={{
      name: "Kredytomat",
      description:
        "Potrzebujesz finansowania, dotknęła Cię klęska żywiołowa, a może szukasz ubezpieczenia dla swojego gospodarstwa rolnego? Pomożemy Ci - Agronomist",
      mediaCoverUrl: imageUrl,
    }}
  >
    <Hero {...COPY.HERO} />
    <Benefits {...COPY.BENEFITS} pt="4rem" pb="4rem" />
    <BenefitsTable id="ofert" {...COPY.BENEFITS_TABLE} />
    <TempShareButtonsComponent />
    <InvestmentCalculatorPlaceholder>
      <CalculatorPage isSeparate />
    </InvestmentCalculatorPlaceholder>
    <Benefits {...COPY.BENEFITS2} pt="4rem" pb="4rem" />
    <DownloadDocuments {...COPY.DOWNLOAD_DOCUMENTS} />
    <Disclaimer {...COPY.DISCLAIMER} />
    <ContactForm onSubmit={onContactSubmit} />
  </PageTemplate>
);

export default KredytyNaInstalacjePVRzeczowka;
